import {useTranslation} from 'react-i18next';
import Header from './components/Header';
import GroupsTable from './components/GroupsTable';
import AddEditGroupDialog from './components/AddEditGroupDialog';

function GroupsMain() {
  const {i18n} = useTranslation();
  const isHebrew = i18n.language === 'heb';

  return (
    <>
      <div
        className={`flex-1 min-h-0 flex flex-col ${
          isHebrew ? 'rounded-tl-[32px]' : 'rounded-tr-[32px]'
        }`}>
        {/* Header */}
        <Header />

        <GroupsTable />
      </div>

      <AddEditGroupDialog />
    </>
  );
}

export default GroupsMain;
